import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListeClientsComponent } from './components/liste-clients/liste-clients.component';
import { PrestationClientsComponent } from './components/prestation-clients/prestation-clients.component';
import { DetailsClientsComponent } from './components/liste-clients/details-clients/details-clients.component';
import { ConsultantclientComponent } from './components/consultantclient/consultantclient.component';
import { esnAbonneNonabonneeGuard } from '@core/guards/esn-abonne-nonabonnee.guard';
import { AddClientComponent } from './components/liste-clients/add-client/add-client.component';
import { EditClientComponent } from './components/liste-clients/edit-client/edit-client.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'liste',
    pathMatch: 'full',
  },
   {
    path:'ajouter-client',
    component:AddClientComponent,
  },
    {
    path:'modifier-client/:id',
    component:EditClientComponent,
  },
  {
    path:'liste',
    component:ListeClientsComponent,
    // canActivate: [esnAbonneNonabonneeGuard.canActivate]
  },
  {
    path:'details-client/:id',
    component:DetailsClientsComponent,
    // canActivate: [esnAbonneNonabonneeGuard.canActivate]
  },
  {
    path:'prestations',
    component:PrestationClientsComponent,
    // canActivate: [esnAbonneNonabonneeGuard.canActivate]
  },
  {
    path:'listconsultant/:id',
    component:ConsultantclientComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientsRoutingModule { }
